module.exports = __webpack_public_path__ + "img/5-1.3875285f.png";